import React from 'react';
import { Flex, Box, Text, Image, Icon } from '@chakra-ui/react';
import { BsChevronRight } from 'react-icons/bs';

interface Props {
  data: any;
  phoneWidth: number;
}

const RedirectTitle: React.FC<Props> = ({ data }) => {
  return (
    <Box
      borderRadius="15px"
      _hover={{ bg: 'gray.200' }}
      backgroundColor="gray.100"
      transition="150ms ease"
      position="relative"
      p={3}
      margin="5px 0 5px 0"
    >
      <>
        <Flex
          justifyContent="space-between"
          alignContent="center"
          alignItems="center"
        >
          {data?.items?.[0]?.file?.url ? (
            <Flex>
              <Image src={data.items[0].file.url} w="25px" h="25px" mr={3} />
              <Text fontWeight="bold" fontSize="md" color="blackAlpha.800">
                {data?.name}
              </Text>
            </Flex>
          ) : (
            <Text fontWeight="bold" fontSize="md" color="blackAlpha.800">
              {data?.name}
            </Text>
          )}

          {data?.items?.[0]?.file ? (
            <Icon as={BsChevronRight} />
          ) : (
            <Text
              fontWeight={data?.items[0]?.weight || 'black'}
              fontSize="md"
              color="blackAlpha.1000"
              textDecorationLine="underline"
            >
              {data?.items[0]?.name}
            </Text>
          )}
        </Flex>
      </>
    </Box>
  );
};

export default RedirectTitle;
